import { Injectable, Input } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const InputLabelMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class InputLabelLabel extends Clazz {
    @Input()
    public inputLabelText: string | null = null;

    @Input()
    public inputLabelIconStart: string | null = null;

    @Input()
    public inputLabelIconEnd: string | null = null;

    /**
     * may be provided by friend mixin so hint.
     */
    required?: boolean;
  }

  return InputLabelLabel;
};
export const InputLabelMixinInputs = ["inputLabelText", "inputLabelIconStart", "inputLabelIconEnd"];
